import { isLoggedInUser } from 'utils/isLoggedInUser';
import { genesysSubcribeEvents, restoreGenesysConfig } from './genesys';
import { registerAuthPlugin } from './registerAuthPlugin';
import { getHasActiveAuthConversation } from 'active-auth-conversation/active-auth-conversation';

export const genesysBootstrap = async () => {
  genesysSubcribeEvents();

  if (isLoggedInUser()) {
    restoreGenesysConfig();
    (await getHasActiveAuthConversation()) && registerAuthPlugin();
  }
};
